import { ScenarioAllocatedUpgrade } from "in_queue/types/scenarioResultType";

import { ViewType } from "../ribbon/ViewTypesMenu";

// Per-row external filter decision for the Allocated Upgrades table.
//
// hideUnpaidRelatedRows (PJM): a related project's $0 row (potential aggregate or contingent) is
// hidden in the Related view. That project overloads the facility but pays nothing for the
// upgrade, so the row says nothing about shared cost. The current project's own rows always
// show, so a potential contributor still sees itself at $0 next to the projects that pay.
export const doesAllocatedUpgradePassFilter = (
    row: Pick<ScenarioAllocatedUpgrade, "projectId" | "allocatedCost">,
    viewType: ViewType,
    currentProjectId: string,
    relatedProjectIds: Set<string>,
    hideUnpaidRelatedRows: boolean
): boolean => {
    if (viewType === "all") {
        return true;
    }
    if (row.projectId === currentProjectId) {
        return true;
    }
    if (viewType === "related" && relatedProjectIds.has(row.projectId)) {
        if (hideUnpaidRelatedRows) {
            return row.allocatedCost > 0;
        }
        return true;
    }
    return false;
};
